"use client"
/* */
import { isFlowComponentName } from '../isFlowComponentName.mjs';
import { pickBy } from 'remeda';

const pickPropsContext = (props) => pickBy(props, (_, k) => isFlowComponentName(k));

export { pickPropsContext };
//# sourceMappingURL=pickPropsContext.mjs.map
